type MessageType = 'OnboardingIntegration'

type MessageContent = {
  OnboardingIntegration: { platform: string }
}

export default function getIntercomMsg<T extends MessageType>(
  type: T,
  context: MessageContent[T],
) {
  const ctx = context as any
  switch (type) {
    case 'OnboardingIntegration':
      return `I have products on ${ctx.platform}. Help me import my product catalog.`
    default:
      return ''
  }
}

export function shouldTrackIntercomEvent(user: any, isChat = false) {
  return isChat || !user?.logged_in_as
}

export enum IntercomEvent {
  'feature-disabled' = 'feature-disabled',
  'credit-card-subscribe-is-invoked' = 'credit-card-subscribe-is-invoked',
  'credit-card-upgrade-is-invoked' = 'credit-card-upgrade-is-invoked',
  'credit-card-new-card-is-invoked' = 'credit-card-new-card-is-invoked',
  'credit-card-one-time-is-invoked' = 'credit-card-one-time-is-invoked',
  'credit-card-checkout-is-invoked' = 'credit-card-checkout-is-invoked',
  'credit-card-subscribe-is-failed' = 'credit-card-subscribe-is-failed',
  'credit-card-upgrade-is-failed' = 'credit-card-upgrade-is-failed',
  'credit-card-new-card-is-failed' = 'credit-card-new-card-is-failed',
  'credit-card-one-time-is-failed' = 'credit-card-one-time-is-failed',
  'credit-card-checkout-is-failed' = 'credit-card-checkout-is-failed',
  'batchimport-visited' = 'batchimport-visited',
  'url-added' = 'url-added',
  'ismine-url-added' = 'ismine-url-added',
  'add-url-failed' = 'add-url-failed',
  'product-added' = 'product-added',
  'add-product-failed' = 'add-product-failed',
  'logout-success' = 'logout-success',
  'dashboard-visited' = 'dashboard-visited',
  'panel-visited' = 'panel-visited',
  'pricing-page-visited' = 'pricing-page-visited',
  'export-requested' = 'export-requested',
  'export-request-failed' = 'export-request-failed',
  'product-source-visited' = 'Product Source -> Visited',
  'competitor-source-visited' = 'Competitor Source -> Visited',
  'Bulk Action -> Competitor Tab Clicked' = 'Bulk Action -> Competitor Tab Clicked',
  'Bulk Action -> Brand Tab Clicked' = 'Bulk Action -> Brand Tab Clicked',
  'Bulk Action -> Category Tab Clicked' = 'Bulk Action -> Category Tab Clicked',
  'Bulk Action -> Product Tab Clicked' = 'Bulk Action -> Product Tab Clicked',
  'Bulk Action -> Products Moved to Another Brand' = 'Bulk Action -> Products Moved to Another Brand',
  'Bulk Action -> Product Saved' = 'Bulk Action -> Product Saved',
  'Bulk Action -> Products Moved to Another Category' = 'Bulk Action -> Products Moved to Another Category',
  'Bulk Action -> Product Edit Button Clicked' = 'Bulk Action -> Product Edit Button Clicked',
  'Bulk Action -> Product Delete Button Clicked' = 'Bulk Action -> Product Delete Button Clicked',
  'Bulk Action -> Brand Deleted and Products Moved to Another Brand' = 'Bulk Action -> Brand Deleted and Products Moved to Another Brand',
  'Bulk Action -> Brand Delete Button Clicked' = 'Bulk Action -> Brand Delete Button Clicked',
  'Bulk Action -> Brand Edit Button Clicked' = 'Bulk Action -> Brand Edit Button Clicked',
  'Bulk Action -> Brand Saved' = 'Bulk Action -> Brand Saved',
  'Bulk Action -> Category Deleted and Products Moved to Another Category' = 'Bulk Action -> Category Deleted and Products Moved to Another Category',
  'Bulk Action -> Category Delete Button Clicked' = 'Bulk Action -> Category Delete Button Clicked',
  'Bulk Action -> Category Edit Button Clicked' = 'Bulk Action -> Category Edit Button Clicked',
  'Bulk Action -> Category Saved' = 'Bulk Action -> Category Saved',
  'Bulk Action -> Product Deleted' = 'Bulk Action -> Product Deleted',
  'Bulk Action -> Multiple Products Deleted' = 'Bulk Action -> Multiple Products Deleted',
  'Bulk Action -> Competitor Deleted' = 'Bulk Action -> Competitor Deleted',
  'Bulk Action -> Competitor Delete Button Clicked' = 'Bulk Action -> Competitor Delete Button Clicked',
  'Bulk Action -> Multiple Competitors Deleted' = 'Bulk Action -> Multiple Competitors Deleted',
  'Bulk Action -> Submit Button Clicked for "Delete Selected" option' = 'Bulk Action -> Submit Button Clicked for "Delete Selected" option',
  'Bulk Action -> Submit Button Clicked for "Move to Another Brand" option' = 'Bulk Action -> Submit Button Clicked for "Move to Another Brand" option',
  'Bulk Action -> Submit Button Clicked for "Move to Another Category" option' = 'Bulk Action -> Submit Button Clicked for "Move to Another Category" option',
}

export enum IntercomUpdate {
  // billing.js
  'subscribed_at' = 'subscribed_at',
  // {"subscribed_at": subscribedAt}
}
